import { COUNTRY_CODE_PATTERN } from '~/utils/localePattern';

const LOCALE_SEGMENT_REGEX = new RegExp(`^(${COUNTRY_CODE_PATTERN})-([a-z]{2})$`, 'i');

export type ParsedLocale = {
    country: string | null;
    language: string | null;
};

export function parseLocaleFromPath(path: string): ParsedLocale | null {
    const segment = path.split('/').filter(Boolean)[0] ?? '';
    const match = LOCALE_SEGMENT_REGEX.exec(segment);

    if (!match) {
        return null;
    }

    return {
        country: match[1]?.toLowerCase() ?? null,
        language: match[2]?.toLowerCase() ?? null
    };
}
